<template>
  <div class="publication-search">
    <div class="publication-search__content">
      <div v-if="!hideFilters"
           class="publication-search__filters">
        <div class="publication-search__filter">
          <div class="search-filter-dropdown">
            <v-select
              v-model="category"
              :options="categoryOptions"
              :reduce="x => x.value"
              placeholder="Category">
            </v-select>
          </div>
        </div>

        <div class="publication-search__filter">
          <div class="search-filter-dropdown">
            <v-select
              v-model="age"
              :options="ageOptions"
              :reduce="x => x.value"
              placeholder="Age">
            </v-select>
          </div>
        </div>

        <div class="publication-search__filter">
          <div class="search-filter-dropdown">
            <v-select
              v-model="format"
              :options="formatOptions"
              :reduce="x => x.value"
              placeholder="Product format">
            </v-select>
          </div>
        </div>

        <div class="publication-search__filter publication-search__filter--checkbox">
          <b-checkbox
            v-model="free">
            Show Free
          </b-checkbox>
        </div>

        <div class="publication-search__filter publication-search__filter--grow">
          <div class="search-filter-dropdown">
            <SimpleTextBox
              v-model="query"
              placeholder="Search by author, title or words">
            </SimpleTextBox>
          </div>
        </div>
      </div>

      <div v-if="loading">
        <div class="publication-search__loading">
          <font-awesome-icon icon="spinner"
                             spin></font-awesome-icon>
        </div>
      </div>

      <div v-else
           class="publication-search__results">
        <div v-if="!Array.isArray( results ) || results.length === 0"
             class="publication-search__no-results">
          No results
        </div>

        <div v-for="result in results"
             v-else
             :key="result.url"
             class="publication-search__result">
          <PublicationSearchResult v-bind="result"></PublicationSearchResult>
        </div>
      </div>

      <div v-if="results && results.length > 0"
           class="publication-search__pagination">
        <SimpleSearchPagination :page-count="pageCount"
                                :page-index="pageIndex"
                                @changePage="changePage">
        </SimpleSearchPagination>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import PublicationSearchResult from "~/Components/Search/PublicationSearchResult.vue";
import SimpleSearchPagination from "~/Components/Search/SimpleSearchPagination.vue";
import SimpleTextBox from "~/Components/Search/Filters/SimpleTextBox.vue";
import searchMixin from "~/Scripts/mixins/searchMixin";

export default {
  name: "PublicationSearch",
  components: {
    PublicationSearchResult,
    SimpleSearchPagination,
    SimpleTextBox,
    vSelect,
  },
  mixins: [searchMixin],
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/colors.less";

.publication-search {
  &__filters {
    padding: 15px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media ( max-width: 991px ) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &__filters-heading {
    font-weight: 600;
    margin-right: 15px;
    font-size: 14px;
    margin-bottom: 0;
    flex-shrink: 0;

    @media ( max-width: 991px ) {
      margin-bottom: 15px;
    }
  }

  &__filter {
    margin-right: 15px;
    flex-basis: 100%;

    &--grow {
      flex-grow: 1;
      flex-basis: 150%;
    }

    &--checkbox {
      flex-basis: 120px;

      .custom-control {
        width: 120px;
      }
    }

    @media ( max-width: 991px ) {
      width: 100%;
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &__results {
    display: flex;
    flex-wrap: wrap;
    margin-left: -7.5px;
    margin-right: -7.5px;
  }

  &__result {
    flex-basis: 25%;
    flex-grow: 0;
    flex-shrink: 0;
    display: flex;
    padding: 0 7.5px;

    @media ( max-width: 991px ) {
      flex-basis: 100%;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__no-results {
    text-align: center;
    font-weight: 600;
    color: @color-accent-6;
    flex-grow: 1;
    padding-top: 30px;
    padding-bottom: 30px;
  }

  &__loading {
    text-align: center;
    font-size: 50px;
    color: @color-accent-6;
  }

  &__checkboxes {
    display: flex;
    justify-content: space-between;
  }

  &__checkbox {
    margin-bottom: 0;

    @media ( max-width: 768px ) {
      > div {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
      }
    }

    @media ( min-width: 401px ) and ( max-width: 768px ) {
      .custom-checkbox {
        flex-basis: 33.33%;
        margin-right: 0;
      }
    }

    @media ( max-width: 400px ) {
      .custom-checkbox {
        flex-basis: 50%;
        margin-right: 0;
      }
    }
  }

  &__textbox {
    border: 2px solid #bbdbdd;
    padding: 2px 5px;
    font-size: 14px;
    width: 100%;

    @media ( min-width: 992px ) {
      width: 220px;
    }
  }

  /deep/ .vs__dropdown-toggle {
    padding: 3px 0 5px;
    border-radius: 8px;
  }
}
</style>
